import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { Link } from 'react-router-dom';
import { propFunc, propStr } from '../../../../helpers/custom-prop-types';
const ColumnContentButton = (props) => {
    const { onClick, text, title, to } = props;
    if (to.indexOf('http') === 0) {
        return (_jsx("div", Object.assign({ className: 'custom_button' }, { children: _jsx("a", Object.assign({ className: 'button primary', "data-label": `${title}_${text}`, href: to, onClick: onClick, rel: 'noopener noreferrer', target: '_blank' }, { children: text })) })));
    }
    return (_jsx("div", Object.assign({ className: 'custom_button' }, { children: _jsx(Link, Object.assign({ className: 'button primary', "data-label": `${title}_${text}`, onClick: onClick, to: to }, { children: text })) })));
};
ColumnContentButton.propTypes = {
    onClick: propFunc().isRequired,
    text: propStr().isRequired,
    title: propStr().isRequired,
    to: propStr().isRequired,
};
export default ColumnContentButton;
